export default {
  LOGIN: '/user/login',
  LOGOUT: '/user/outLogin',
  GET_MENU: '/auth/resource/menuList',
  UPDATE_PASSWORD: '/auth/user/changePassword',
  PUBLIC_UPDATE_PASSWORD: '/auth/public/changePassword',
  UPDATE_HEAD_IMG: '/auth/user/updateHeadImg',
  CHANGE_LANGUAGE: '/auth/user/changeLanguage',
  GET_USER_INFO: '/auth/user/getUserInfo',
  GET_PERMISSION: '/auth/resource/permissionsList',
  GET_STATEMENT: '/manage/aboutBasf/loginAboutBasf',
  SEND_EMAIL: '/auth/public/emailLog/sendEMailForForgetPassword',
  FORGET_PASSWORD: '/auth/user/forgetPassword',
  SEND_MESSAGE: '/user/sendUnLockMessage',
  CHECK_PASS: '/public/validPassword',
  SEND_EMAIL_FOR_CHANGE_PWD: '/auth/public/emailLog/sendEMailForChangePassword',
  PUBLIC_SEND_EMAIL_FOR_CHANGE_PWD: '/auth/public/emailLog/sendEMailForChangePw',
  GET_CHECK_CODE: '/auth/getCheckCode',
  SUBMIT_CHECK_CODE: '/auth/checkCode',
  INCR_SCANNED_TIME: '/manage/qr-code/incrScannedTimes',
  GET_REGISTER_CODE: '/auth/public/emailLog/getRegisterCode',
  REGISTER: '/auth/user/apply/register',
  GET_COMPANY_LIST: '/auth/user/companies',
  GET_CUSTOMER_COMPANY_LIST: '/auth/user/customerCompanies',
  UPDATE_SESSION: '/auth/user/update/session',
  CHECK_ACCOUNT: '/auth/user/check/account',
  ACTIVATE: '/auth/user/url/activate',
  REACTIVATE: '/auth/user/reActivate',
  UPDATE_USER_INFO: '/auth/user/update',
  GET_DEGRETION_INFO: '/auth/user/apply/getDegretionInfo',
  WRITTEN_OFF: '/auth/user/apply/writtenOff',
  CHECK_PASSWORD: '/auth/user/checkPassword',
  PUBLIC_CHECK_PASSWORD: '/auth/public/checkPassword',
  CHECK_NEW_PASSWORD: '/auth/public/checkNewPassword',
  getCustomerCompanyData: '/auth/user/new/customerCompanies',
  unlockEmailWhetherSent: '/auth/public/unlockEmailWhetherSent'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/login.js